import { endpointsBackOffice } from "../api/endpoints"
import { API } from "./comunApi"

export const configApi = {
    getAuthStatus: async () => {
        return await API.get(
            endpointsBackOffice.GET_CONFIG_AUTH_STATE_PESENTATION_CONTACT
        )
    },
    updateAuthStatus: params => (
        API.put(
            endpointsBackOffice.UPDATE_CONFIG_AUTH_STATE_PESENTATION_CONTACT,
            params
        )
    ),

  
}